$('.page-content.na-midia').each(function () {
	var page = $(this);

	page.find('.lista-comentarios').owlCarousel({
        items: 1,
        loop: true,
        nav: false,
        dots: true
	});
});
console.log($('.page-content.na-midia'));
